<template>
  <picker-field :label="label" :display="display" :is-focus="isFocus" title="选择科目" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="ca_code,ca_desc"
        placeholder="输入科目编号、名称进行查找"
        ref="searchBar"
      />
    </template>
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.ca_code}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ca_desc}}</p>
          </div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";

export default {
  components: {
    PickerField,
    SearchBar
  },
  props: {
    label: {
      type: String,
      default: "科目"
    },
    // category.id
    value: Number
  },
  data() {
    return {
      isFocus: false,
      // category.ca_code + ' ' + category.ca_desc
      display: null,
      params: {
        number: 1,
        size: 10
      },
      items: []
    };
  },
  watch: {
    value() {
      // 单据read接口返回数据，科目ID有值，此处需要按科目ID加载并显示科目名称
      var me = this;
      if (!me.firechange) {
        me.getOne();
      }
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.firechange = true;
      me.$emit("input", item.id);
      me.$emit("select", item);
      me.display = item.ca_code + " " + item.ca_desc;
      me.$refs.picker.close();
    },
    getCondition() {
      var filterCondition = [],
        searchBar = this.$refs.searchBar,
        searchCondition = searchBar.getCondition();
      if (searchCondition) {
        filterCondition.push(searchCondition);
      }
      return filterCondition;
    },
    onSearch() {
      var me = this,
        condition = me.getCondition();
      me.$loading({
        url: "/api/finance/category/list",
        params: Object.assign(
          {
            condition: JSON.stringify(condition)
          },
          me.params
        )
      }).then(function(res) {
        if (res.success) {
          me.items = res.data.list;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    /**
     * 按ID查找科目
     */
    getOne() {
      var me = this;
      me.$loading({
        url: "/api/finance/category/read/" + me.value
      }).then(function(res) {
        if (res.success) {
          var item = res.data;
          me.display = item.ca_code + " " + item.ca_desc;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>